const config = {
  // Site info
  siteTitle: "Lam Pham Blog", // Site title.
  siteTitleShort: "Lam Pham Blog", // Short site title for homescreen (PWA). Preferably should be under 12 characters to prevent truncation.
  siteTitleAlt: "Lam Pham Blog", // Alternative site title for SEO.
  siteLogo: "/logos/logo-1024x1024.png", // Logo used for SEO and manifest.
  siteUrl: "https://phamvanlam.com", // Domain of your website without pathPrefix.
  pathPrefix: "", // Prefixes all links. For cases when deployed to example.github.io/gatsby-advanced-starter/.
  siteDescription: "Chuyên chia sẻ về Linux và phần mềm mã nguồn mở", // Website description used for RSS feeds/meta description tag.
  siteRss: "/rss.xml", // Path to the RSS file.
  siteLang: "vi",
  siteFBAppID: "507662393356111", // FB Application ID for using app insights
  googleAnalyticsID: "UA-96543695-3", // GA tracking ID.
  postDefaultCategoryID: "", // Default category for posts.
  // Common for tag, category pages and widget
  numberLatestPost: 8,
  postsPerPage: 8,
  // Use for post
  dateFromFormat: "YYYY-MM-DDTHH:mm:ssZ", // Date format used in the frontmatter.
  dateFormat: "MMMM Do, YYYY", // Date format for display.
  postTagged: "",
  postInCategories: "",
  postOnDate: "Posted on",
  // Use for comment
  lazyLoadComments: true,
  disqusShortname: "lam-pham-blog", // Disqus shortname.
  btnLoadComments: "Xem bình luận",
  // Use for home page
  numberLoadmore: 6,
  btnLoadmore: "Xem thêm",
  homeHasLoadmore: false,
  homeHasThumbnail: true,
  homeHeader: "Trang chủ",
  homeMoreArticles: "Xem thêm",
  // Use for page
  pathPrefixPagination: "/page", // Prefix path for pagination
  pageNotFoundTitle: "Trang không tồn tại", //
  pageNotFoundBtn: "Quay về trang chủ",
  pageNotFoundContent:
    "Rất tiếc, trang bạn đang tìm kiếm không tồn tại hoặc liên kết đã bị thay thế.",
  // Use for tag
  pathPrefixTag: "/tag", // Prefix path for tags
  tagHeader: "Chủ đề", // use in header of tag-template page
  tagHasThumbnail: true,
  // Use for category
  pathPrefixCategory: "/category", // Prefix path for category
  categoryHeader: "Chuyên mục", // use in header of category-template page
  categoryHasThumbnail: true,
  // Use for blog
  pathPrefixBlog: "/blog", // Prefix path for blog
  blogHeader: "Blog", // use in header of category-template page
  blogHasThumbnail: true,
  // Use for widget
  categoryWidgetTitle: "Chuyên mục",
  tagWidgetTitle: "Chủ đề",
  latestPostsWidgetTitle: "Bài viết mới nhất",
  linksWidgetTitle: "Liên Kết",
  // Use for Google custom search
  searchWidgetTitle: "Bạn đang tìm gì?",
  searchWidgetPlaceHolder: "Nhập từ khóa",
  searchEngineID: "partner-pub-7260245524211186:5425507331",
  hasSearch: true,
  // Set up for google adsense
  hasAdsense: true,
  adsClient: "ca-pub-7260245524211186",
  adsenseUnits: {
    sidebarTop: {
      client: "ca-pub-7260245524211186",
      slot: "5920255992",
      style: { display: "inline-block", width: "300px", height: "250px" },
      format: "",
    },
    sidebarMiddle: {
      client: "ca-pub-7260245524211186",
      slot: "9939184839",
      style: { display: "inline-block", width: "300px", height: "250px" },
      format: "",
    },
    sidebarBottomRight: {
      client: "ca-pub-7260245524211186",
      slot: "4957801764",
      style: { display: "inline-block", width: "300px", height: "250px" },
      format: "",
    },
    sidebarBottomLeft: {
      client: "ca-pub-7260245524211186",
      slot: "4087452035",
      style: { display: "inline-block", width: "300px", height: "600px" },
      format: "",
    },
    postTopSmall: {
      client: "ca-pub-7260245524211186",
      slot: "2657498136",
      style: {
        display: "block",
        width: "320px",
        height: "50px",
        margin: "0 auto",
      },
      format: "",
    },
    postTopSmall2: {
      client: "ca-pub-7260245524211186",
      slot: "5140191249",
      style: {
        display: "block",
        width: "728px",
        height: "90px",
        margin: "0 auto",
      },
      format: "",
    },
    postTop: {
      client: "ca-pub-7260245524211186",
      slot: "2326348116",
      style: { display: "block" },
      format: "auto",
      responsive: "true",
    },
    postBottom: {
      client: "ca-pub-7260245524211186",
      slot: "4961671191",
      style: { display: "block" },
      format: "auto",
      responsive: "true",
    },
  },
  // Use for links widget
  sidebarSticky: true,
  sidebarLinks: [
    { label: "Complete JavaScript", url: "https://completejavascript.com/" },
    { label: "ToolsKit Plus", url: "https://toolskitplus.com/" },
    { label: "Blog Thuật toán", url: "https://thuattoan.phamvanlam.com/" },
    { label: "Lam Dev Blog", url: "https://dev.phamvanlam.com/" },
    { label: "Amazing CSS", url: "https://css.completejavascript.com/" },
    { label: "My Portfolio", url: "http://about.phamvanlam.com/" },
    // {
    //   label: "My Android Apps",
    //   url: "https://play.google.com/store/apps/developer?id=LamPV",
    // },
  ],
  // Use for user info
  userName: "Admin", // Username to display in the author segment.
  userEmail: "admin@phamvanlam.com", // Email used for RSS feed"s author segment
  userTwitter: "", // Optionally renders "Follow Me" in the UserInfo segment.
  userLocation: "Hanoi, Vietnam", // User location to display in the author segment.
  userAvatar:
    "https://www.gravatar.com/avatar/42fd3d526fde1ef76d5002e4ebd303e9.jpg?s=300", // User avatar to display in the author segment.
  userDescription:
    "Software Engineer, Web Developer, JavaScript Lover & Blogger @completejavascript.", // User description to display in the author segment.
  // Links to social profiles/projects you want to display in the author segment/navigation bar.
  userLinks: [
    {
      label: "Email",
      url: "mailto:admin@phamvanlam.com",
      iconClassName: "far envelope",
    },
    {
      label: "Website",
      url: "https://about.phamvanlam.com/",
      iconClassName: "fas globe",
    },
    {
      label: "Facebook",
      url: "https://www.facebook.com/hdopensource/",
      iconClassName: "fab facebook-f",
    },
    {
      label: "Linkedin",
      url: "https://www.linkedin.com/in/completejavascript/",
      iconClassName: "fab linkedin-in",
    },
  ],
  // Use for navigation
  navTitle: "Lam Pham Blog",
  navLinks: [
    { label: "Giới thiệu", url: "/gioi-thieu" },
    { label: "Liên hệ", url: "/lien-he" },
  ],
  // Use for footer
  socialLinks: [
    {
      label: "Codepen",
      url: "https://codepen.io/completejavascript/",
      iconClassName: "fab codepen",
    },
    // {
    //   label: "FreeCodeCamp",
    //   url: "https://www.freecodecamp.org/completejavascript",
    //   iconClassName: "fab free-code-camp",
    // },
    {
      label: "GitHub",
      url: "https://github.com/completejavascript",
      iconClassName: "fab github",
    },
    {
      label: "Facebook",
      url: "https://www.facebook.com/hdopensource/",
      iconClassName: "fab facebook-f",
    },
    {
      label: "Linkedin",
      url: "https://www.linkedin.com/in/completejavascript/",
      iconClassName: "fab linkedin-in",
    },
    {
      label: "RSS",
      url: "https://phamvanlam.com/rss.xml",
      iconClassName: "fas rss",
    },
  ],
  footerLinks: [
    { label: "Trang chủ", url: "/" },
    { label: "Giới thiệu", url: "/gioi-thieu" },
    { label: "Liên hệ", url: "/lien-he" },
    { label: "Điều khoản sử dụng", url: "/dieu-khoan-su-dung" },
    { label: "Chính sách bảo mật", url: "/chinh-sach-bao-mat" },
    { label: "Sitemap", url: "https://phamvanlam.com/sitemap.xml" },
  ],
  copyright:
    "Copyright © 2017-2022 Lam Pham. Unless otherwise noted, all code MIT license.",
  // Use for manifest
  themeColor: "#2196F3", // Used for setting manifest and progress theme colors.
  backgroundColor: "#FFF", // Used for setting manifest background color.
};

// Validate

// Make sure pathPrefix is empty if not needed
if (config.pathPrefix === "/" || config.pathPrefix === "") {
  config.pathPrefix = "";
} else {
  // Make sure pathPrefix only contains the first forward slash
  config.pathPrefix = `/${config.pathPrefix.replace(/^\/|\/$/g, "")}`;
}

// Make sure siteUrl doesn't have an ending forward slash
if (config.siteUrl.substr(-1) === "/")
  config.siteUrl = config.siteUrl.slice(0, -1);

// Make sure siteRss has a starting forward slash
if (config.siteRss && config.siteRss[0] !== "/")
  config.siteRss = `/${config.siteRss}`;

module.exports = config;
